import React, { useMemo } from 'react';
import { selectConfigSettings } from '../../../../store/slices/config/configSelectors';
import {
  selectPaymentFees,
  selectSelectedPaymentMethod,
} from '../../../../store/slices/payment/paymentSelectors';
import { Grid, Row, Col, Text } from 'rsuite';
import { useSelector } from 'react-redux';
import { convertNumberToCurrency } from '../../../../common/utils';
import {
  calculateProcessingFee,
  getProcessingFeeLabel,
  calculateTotalDue,
  isGeneric,
} from '../utils';

const PaymentSummary = () => {
  const settings = useSelector(selectConfigSettings);
  const provider = settings?.paymentProcessor;
  const isGenericProvider = useMemo(() => isGeneric(provider), [provider]);
  const paymentFees = useSelector(selectPaymentFees);
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

  const totalDue = useMemo(
    () =>
      calculateTotalDue(selectedPaymentMethod, paymentFees, isGenericProvider),
    [selectedPaymentMethod, paymentFees, isGenericProvider]
  );

  const processingFee = useMemo(
    () =>
      calculateProcessingFee(
        selectedPaymentMethod,
        paymentFees,
        isGenericProvider
      ),
    [selectedPaymentMethod, paymentFees, isGenericProvider]
  );

  const processingFeeLabel = useMemo(
    () => getProcessingFeeLabel(selectedPaymentMethod),
    [selectedPaymentMethod]
  );

  return (
    <Grid
      fluid
      data-testid="payment-summary-component"
    >
      <Row>
        <Col
          xs={12}
          lg={24}
          className="mb-16"
        >
          <Text className="mb-8">Total Amount Due</Text>
          <Text className="header-text-h3 text-bold">
            {convertNumberToCurrency(totalDue)}
          </Text>
        </Col>
        <Col
          xs={12}
          lg={24}
        >
          <div role="grid">
            {paymentFees?.breakdown?.map((item, index) => (
              <Row
                key={index}
                className="mb-8"
              >
                <Col xs={24}>
                  <Text className="text-small">{item.label}</Text>
                  <Text>{convertNumberToCurrency(item.value)}</Text>
                </Col>
              </Row>
            ))}
            {!isGenericProvider && (
              <Row>
                <Col xs={24}>
                  <Text className="text-small">{processingFeeLabel}</Text>
                  <Text>{convertNumberToCurrency(processingFee)}</Text>
                </Col>
              </Row>
            )}
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default PaymentSummary;
